
// src/pages/auth/OwnerSignupForm.js
import React, { useState } from 'react';
import '../shop_registration_styles.css';

function OwnerSignupForm({ onNext }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: 'US',
    password: '',
    confirmPassword: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  // Helpers (kept minimal to preserve UI)
  const normalizeEmail = (email = '') => email.trim().toLowerCase();
  const isStrongPassword = (pw = '') =>
    pw.length >= 8 && /[A-Z]/.test(pw) && /[a-z]/.test(pw) && /\d/.test(pw) && /[^A-Za-z0-9]/.test(pw);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Lightweight validations (alerts keep your current look)
    const emailNorm = normalizeEmail(formData.email);
    if (!formData.firstName?.trim() || !formData.lastName?.trim() || !emailNorm || !formData.password) {
      alert('Please fill in all required fields.');
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match.');
      return;
    }
    if (!isStrongPassword(formData.password)) {
      alert('Password must be at least 8 characters and include upper, lower, digit, and special character.');
      return;
    }

    // Validate professional type if checkbox is checked
    if (formData.isAlsoProfessional && !formData.professionalType) {
      alert('Please select a professional type.');
      return;
    }

    // Build payload exactly as backend expects
    const dataToSend = {
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim(),
      email: emailNorm,
      phone: formData.phone?.trim() || '',
      country: formData.country,
      password: formData.password,
      isAlsoProfessional: formData.isAlsoProfessional,
      professionalType: formData.isAlsoProfessional ? formData.professionalType : undefined
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/owners/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSend)
      });
      const result = await response.json();
      if (response.ok && result.status === 'success') {
        setSubmitted(true);
      } else {
        alert(result.message || 'Error registering owner');
      }
    } catch (err) {
      alert('Error registering owner');
    }
  };

  if (submitted) {
    return (
      <div className="form-card classy-card">
        <h2 className="classy-title">Check Your Email</h2>
        <p className="classy-text">
          We've sent a verification link to <strong>{normalizeEmail(formData.email)}</strong>.<br />
          Please click the link in your email to continue registration.
        </p>
      </div>
    );
  }

  return (
    <div className="form-card classy-card">
      <h2 className="classy-title">Owner Information</h2>
      <p className="classy-text">Please enter your details to register as a shop owner.</p>

      <form onSubmit={handleSubmit} className="classy-form">
        <div className="classy-field">
          <input
            name="firstName"
            type="text"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
            className="classy-input"
          />
        </div>

        <div className="classy-field">
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
            className="classy-input"
            style={{ width: '100%' }}
          >
            <option value="US">🇺🇸 United States</option>
            <option value="CA">🇨🇦 Canada</option>
            <option value="GB">🇬🇧 United Kingdom</option>
            <option value="NG">🇳🇬 Nigeria</option>
            <option value="AU">🇦🇺 Australia</option>
          </select>
        </div>

        <div className="classy-field">
          <input
            name="lastName"
            type="text"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
            className="classy-input"
          />
        </div>

        <div className="classy-field">
          <input
            name="email"
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="classy-input"
          />
        </div>

        <div className="classy-field">
          <input
            name="phone"
            type="tel"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
            className="classy-input"
          />
        </div>

        <div className="classy-field">
          <input
            name="password"
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
            className="classy-input"
          />
        </div>

        {/* NEW: Confirm Password */}
        <div className="classy-field">
          <input
            name="confirmPassword"
            type="password"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            className="classy-input"
          />
        </div>

        <button type="submit" className="classy-btn">Register</button>
        
        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Already have an account? <a href="/login" style={{ color: '#003087', textDecoration: 'none', fontWeight: '600' }}>Login here</a>
          </p>
        </div>
      </form>
    </div>
  );
}

export default OwnerSignupForm;
